import attendanceTypes from 'constants/attendanceTypes';
import { useEffect, useState } from 'react';
import { Society } from 'types';
import { getFullAddress } from 'utils/filters';

type UseGetAttendanceModesProps = {
  actualSociety?: Society;
  attendanceType: string;
  place?: string;
  onlineAccess?: string;
};

export const useGetAttendanceModes = ({
  actualSociety,
  attendanceType,
  place: initialPlace,
  onlineAccess: initialOnlineAccess,
}: UseGetAttendanceModesProps) => {
  const [place, setPlace] = useState<string>(initialPlace || '');
  const [onlineAccess, setOnlineAccess] = useState<string>(
    initialOnlineAccess || ''
  );

  const handleChangePlace = (value: string) => {
    setPlace(value);
  };

  const handleChangeOnlineAccess = (value: string) => {
    setOnlineAccess(value);
  };

  useEffect(() => {
    switch (attendanceType) {
      case attendanceTypes.FACE_TO_FACE.value:
        setOnlineAccess('');
        setPlace(initialPlace || initialOnlineAccess || '');
        break;
      case attendanceTypes.ONLINE.value:
        setPlace('');
        setOnlineAccess(initialOnlineAccess || onlineAccess || '');
        break;
      case attendanceTypes.WRITTEN_NO_SESSION.value:
        setPlace('');
        setOnlineAccess('');
        break;
      default: {
        const societyAddress = getFullAddress(actualSociety?.legalAddress);
        setPlace(initialPlace || societyAddress || '');
        setOnlineAccess(initialOnlineAccess || onlineAccess || '');
        break;
      }
    }
  }, [actualSociety, attendanceType]);

  return {
    data: {
      place,
      onlineAccess,
    },
    actions: {
      handleChangePlace,
      handleChangeOnlineAccess,
    },
  };
};
